import React,{useState,useEffect} from "react";
import AddButtonSection from '../../components/common/AddButtonSection';
import { useForm } from "react-hook-form";
import InputIterator from '../../components/common/inputIterator';
import { profileFormRender as formRender } from "../../utils/serviceData";
import { commonGetApi,commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";
import { useSelector, useDispatch } from "react-redux";
import { userProfile } from "../../redux/commonSlice";
import { Button } from 'primereact/button';
import LeftArrow from '../../assets/images/leftArrow'
import Loader from '../../components/common/loader';

const ProfileInfo = () => {
    const {
        control,
        formState: { errors, dirtyFields },
        handleSubmit,
        setValue,
      } = useForm();
  const [isEdit, setIsEdit] = useState(false);
  const [profileId, setProfileId] = useState(null);
  const [loader, setLoader] = useState(false);
  const [profileUser, setProfileUser] = useState({});
  const userDetails = useSelector((state) => state?.common?.user);
  const dispatch = useDispatch()

const onEdit = async (data) => {
  if (loader) return;
  setLoader(true);

  try {
    const response = await commonPostApi(
      API_ENDPOINTS.EDIT_USER_DETAILS,
      { ...data, user_id: profileId }
    );

    if (response?.status === 200 && response?.data?.message !== "No record updated") {
      showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.USER.UPDATED);
      getUserDetails();
    } else {
      showToast(TOAST_TYPE.ERROR, response?.data?.message || COMMON_MSG.ERROR.GENERIC);
    }

  } catch (error) {
    showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
  }

  setLoader(false);
};

  const getUserDetails = async () => {
    await commonGetApi(API_ENDPOINTS.USER_PROFILE).then((data) => {
      if (data?.data?.data) {
        dispatch(userProfile(data?.data?.data));
      }
    });
  };

  var buttons = [
    {
      type: "render",
      class: "col-12 p-0 pt-3",
      render: (
        userDetails && <div className="text-black-alpha-90 text-lg">{userDetails?.['first_name'] + " " + userDetails?.['last_name']}</div>
      ),
    },
    {
      type: "render",
      class: "col-12 p-0 pt-3",
      render: (
        userDetails?.['is_active'] && <Button label="Active" severity="success" className="px-3 py-1 text-xs font-medium cursor-none"/>
      ),
    },
    {
      type: "render",
      class: "col-12 p-0 pt-3",
      render: (
        <div className="msgText font-normal text-sm">
          {userDetails?.['last_logged_on'] 
            ? `Last logged on ${new Date(userDetails['last_logged_on']).toLocaleString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
                month: '2-digit',
                day: '2-digit',
                year: 'numeric'
              }).replace(',', '')}`
            : 'Last logged information not available'
          }
        </div>
      ),
    },
  ];
  var button = [
    {
      type: "primarySuccessButton",
      label: "Save Changes",
      class: "w-11rem pr-3",
      onClick: handleSubmit(onEdit),
    },
    {
      type: "secondaryButton",
      label: "Cancel",
      class: "w-7rem",
    },
  ];

  const editButton = [
    {
      type: "primarySuccessButton",
      label: "Edit",
      class: "col-1",
      onClick: ()=>{setIsEdit(true)},
    }
  ];
 
  const getUser = () => {
    if (userDetails) {
      setProfileId(userDetails?.['user_id']);
      formRender.forEach((group) => {
        group?.item?.forEach((user) => {
          setValue(`${user?.name}`, userDetails[user?.name]);
          setProfileUser((prev) => ({
            ...prev,
            [user?.label] :  userDetails[user?.name]
          }))
        });
      });
    }
  };
  
  useEffect(()=>{
    getUser();
  },[userDetails])
  return (
    <>
      {userDetails ?  (
        <div className="Profile">
          {isEdit &&
            <div className="flex align-items-center gap-2 cursor-pointer mb-4" onClick={()=>{setIsEdit(false)}}>
              <LeftArrow />
              <h3 className="font-medium m-0">User</h3>
            </div>
          }
          <div className="Profile__card">
              <img style={{height:"100px", width:"100px",borderRadius:"4px"}} src={ userDetails?.profile_picture ? `${process.env?.REACT_APP_CURRENT_URL}${API_ENDPOINTS.SEARCH_IMAGE_BY_ID(userDetails?.user_id)}` :  require("../../assets/images/no-picture.jpg")} alt="profile"/>
              <AddButtonSection  buttons={buttons} />
          </div>
          { !isEdit && 
            <>
              <div className="grid">
                {Object.entries(profileUser).map(([key, value]) => (
                  <div className={`${(key === "State" || key === "Pincode") ? "col-12" : "col-6"}`}>
                    <p className="Password__primary text-sm" key={key}>{key}</p>
                    <p className="Password__secondary text-base mb-3 mt-1 ">{value}</p>
                  </div>
                ))}
              </div>
              <AddButtonSection disabled={loader} buttons={editButton} />
            </>
          }
          {isEdit &&
            <>
              <InputIterator
                control={control}
                errors={errors}
                formRender={formRender}
              />
              <div className="pt-3 pl-2">
                <AddButtonSection disabled={Object.keys(dirtyFields).length === 0 || loader} buttons={button} />
              </div>
            </>
          }
        </div>
      )
      :(
        <Loader />
      ) }
    </>
  );
};

export default ProfileInfo;
